import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Service } from './delete-policy.service';
import { TranslateService, TranslatePipe, LangChangeEvent } from '@ngx-translate/core';
import { GlobalVariables } from '../../../../../common/global-variables';
import { DataProtectionVariables } from '../../dataprotection-common/dataprotection-variables';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'delete-policy',
  providers: [
    Service, TranslateService
  ],
  styles: [require('./delete-policy.scss')],
  template: require('./delete-policy.html')
})

export class DeletePolicy {
  @Input('isVisible') isVisible: boolean;
  @Input('mode') mode: string;
  @Input('selectedEntity') selectedEntity;
  @Output('onRequestStatusChange') emitter = new EventEmitter();

  private subscribeHandler;
  private submitted: boolean = false;
  private active: boolean = true;
  private description1 = '';
  private description2 = '';

  private isRequestPending: boolean = false;
  private emitData = {
    'status': '',
  };

  constructor(public service: Service, private translate: TranslateService) {
    translate.use(GlobalVariables.LOCALE);
  }

  onSubmit() {
    this.isRequestPending = true;
    this.emitData.status = 'pending';
    this.emitter.emit(this.emitData);

    switch(this.mode){
      case DataProtectionVariables.POLICY_POPUP_MODES['DELETE_RESOURCE_POOL_POLICY']:
        this.deleteResourcePoolPolicy();
        break;
      case DataProtectionVariables.POLICY_POPUP_MODES['DELETE_VM_POLICY']:
        this.deleteVmPolicy();
        break;
      default :
        this.deleteResourcePoolPolicy();
    }
  }

  onCancelButtonClicked() {
    this.emitter.emit();
  }

  //Life Cycle Hooks
  ngOnInit() {
  }

  ngOnChanges(changes) {
    let name;
    if ( (changes.mode && this.selectedEntity) || (changes.selectedEntity && this.mode) ) {
      name = ( this.selectedEntity && this.selectedEntity.name ) ? this.selectedEntity.name : "";
      if ( this.mode === DataProtectionVariables.POLICY_POPUP_MODES['DELETE_RESOURCE_POOL_POLICY'] ) {
        this.description1 = this.translate.instant('vcDpsModule.deletePolicy.rp.description1') + name;
        this.description2 = this.translate.instant('vcDpsModule.deletePolicy.rp.description2');
      } else if ( this.mode === DataProtectionVariables.POLICY_POPUP_MODES['DELETE_VM_POLICY'] ) {
        this.description1 = this.translate.instant('vcDpsModule.deletePolicy.vm.description1') + name;
        this.description2 = this.translate.instant('vcDpsModule.deletePolicy.vm.description2');
      }
    }
  }

  ngAfterViewInit() {
  }

  ngOnDestroy() {
    if(this.subscribeHandler) this.subscribeHandler.unsubscribe();
  }

  deleteResourcePoolPolicy() {
    if(this.selectedEntity && this.selectedEntity.entity_id !== '' &&
       this.selectedEntity.vcenter_instanceId !== '' ) {
          this.subscribeHandler = this.service.deleteResourcePoolPolicy(this.selectedEntity.entity_id, this.selectedEntity.vcenter_instanceId)
            .subscribe(
              res => {
                this.handleSuccess();
              },
              error => this.handleError(error),
              () => this.logOperationCompleted('deleted resource pool policy')
            );
    }
    else{
    }
  }

  deleteVmPolicy() {
    if(this.selectedEntity && this.selectedEntity.entity_id !== '' &&
       this.selectedEntity.vcenter_instanceId !== '' ) {
      this.subscribeHandler = this.service.deleteVmPolicy(this.selectedEntity.entity_id, this.selectedEntity.vcenter_instanceId)
        .subscribe(
          res => {
            this.handleSuccess();
          },
          error => this.handleError(error),
          () => this.logOperationCompleted('deleted vm policy')
        );
    }
    else{
    }
  }

  handleSuccess() {
    this.isRequestPending = false;
    this.emitData.status = 'success';
    this.emitter.emit(this.emitData);
  }


  handleError(error) {
    this.isRequestPending = false;
    this.emitData.status = 'error';
    this.emitter.emit(this.emitData);
  }

  logOperationCompleted(msg: string) {
    console.log('Operation Completed: ', msg)
  }
}



// WEBPACK FOOTER //
// ./src/app/components/dataprotection/dataprotection-vc/delete-policy/delete-policy.component.ts